<script lang='ts'>
    import LibLoader from "./LibLoader.svelte";
    import { Skeleton } from "$lib/components/ui/skeleton/index.js";
    import { getTypedAm5 } from "@/Util/XertAm5";
    const { am5 } = getTypedAm5()

    let isAm5Loaded = false
    const loaded = () => {isAm5Loaded = true;} 
</script>

<LibLoader url='/js/amcharts.js' on:loaded={loaded} shouldLoadLib={() => !am5} />
{#if isAm5Loaded}
    <slot />
{:else}
    <Skeleton class="w-full aspect-[3/1]" />
{/if}